/**
 * Safely removes a single property from a multi-property CSS value.
 * @param {String} property The property name.
 * @param {String} propertyValue The property value to delete.
 * @return {String|undefined}
 */
const deleteMultiValueProperty = (property, propertyValue) => {
    const regex = new RegExp(`${property}\\((.*?)\\)`);

    if (propertyValue.match(regex)) {
        return propertyValue.replace(regex, '').trim();
    }

    return propertyValue;
};

module.exports = deleteMultiValueProperty;
